<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'sector')"

  >

    <template #addDataForm>
      <sector-add-update></sector-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'sector'">
            <template v-if="get(cell.item, 'id')">
                <sector-cell :data="cell.item"></sector-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'railway'">
            <template v-if="get(cell.value, 'id')">
                <railway-cell :data="cell.value"></railway-cell>
            </template>

        </template>

    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../sectorStoreModule'
  import useSector from '../useSector'

  import SectorAddUpdate from '../components/SectorAddUpdate'
  import SectorCell from "../components/SectorCell";

  import get from 'lodash.get'
  import RailwayCell from "@/views/apps/railway_structure/railway/components/RailwayCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        RailwayCell,
      SectorCell,
      ElementsLayout,
      SectorAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useSector();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
